const BYTES_PER_MB = 1024 * 1024;

const getSizeBytes = (entry) => Number(entry?.file?.size ?? entry?.size ?? 0);

export const getUploadLimitError = (
  existingFiles,
  newFiles,
  { maxFileCount, maxSingleFileSizeMB, maxTotalSizeMB }
) => {
  const files = [...(existingFiles || []), ...(newFiles || [])];
  if (files.length > maxFileCount) {
    return `Cannot upload more than ${maxFileCount} files!`;
  }

  if (files.some((file) => getSizeBytes(file) > maxSingleFileSizeMB * BYTES_PER_MB)) {
    return `File size is greater than ${maxSingleFileSizeMB}MB!`;
  }

  const totalSizeBytes = files.reduce(
    (total, file) => total + getSizeBytes(file),
    0
  );
  if (totalSizeBytes > maxTotalSizeMB * BYTES_PER_MB) {
    return `Total file size exceeds ${maxTotalSizeMB}MB limit. Cannot upload more files.`;
  }

  return null;
};